import { render, staticRenderFns } from "./StoreInit.vue?vue&type=template&id=24967560&"
import script from "./StoreInit.vue?vue&type=script&lang=js&"
export * from "./StoreInit.vue?vue&type=script&lang=js&"
import style0 from "./StoreInit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports